/* CARAVIUM — SEO area ficha URLs */
(() => {
  'use strict';

  const LEGACY_PATH = '/pages/ficha-area-caravium';
  const SEO_PREFIX = '/apps/pernoctar/';
  const GUIDE_PREFIX = '/apps/pernoctar/guia-';
  const SB = 'https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const KEY = 'sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';
  const slugCache = new Map();
  const pending = new Map();

  function extractId(rawHref) {
    if (!rawHref) return null;
    try {
      const u = new URL(rawHref, location.origin);
      if (u.pathname.includes('ficha-area-caravium')) {
        const id = u.searchParams.get('id');
        return id && /^\d+$/.test(id) ? id : null;
      }
      if (u.pathname.startsWith(SEO_PREFIX) && !u.pathname.startsWith(GUIDE_PREFIX)) {
        const m = decodeURIComponent(u.pathname).match(/-(\d+)\/?$/);
        return m ? m[1] : null;
      }
    } catch {}
    return null;
  }

  function seoUrl(slug, sourceHref) {
    const clean = String(slug || '').trim();
    if (!clean) return null;
    let url = `${SEO_PREFIX}${encodeURIComponent(clean).replace(/%2F/gi, '/')}`;
    try {
      const source = new URL(sourceHref || location.href, location.origin);
      const keep = new URLSearchParams();
      ['from_planificar', 'stage'].forEach((key) => {
        const value = source.searchParams.get(key);
        if (value) keep.set(key, value);
      });
      const qs = keep.toString();
      if (qs) url += `?${qs}`;
    } catch {}
    return url;
  }

  async function getSeoUrl(id, sourceHref) {
    const cleanId = String(id || '').trim();
    if (!/^\d+$/.test(cleanId)) return null;
    if (slugCache.has(cleanId)) return seoUrl(slugCache.get(cleanId), sourceHref);
    if (pending.has(cleanId)) {
      const slug = await pending.get(cleanId);
      return slug ? seoUrl(slug, sourceHref) : null;
    }
    const job = (async () => {
      try {
        const r = await fetch(`${SB}/rest/v1/spots?id=eq.${encodeURIComponent(cleanId)}&select=seo_slug&limit=1`,{ headers: { apikey: KEY, Authorization: `Bearer ${KEY}` } });
        if (!r.ok) return null;
        const row = (await r.json())?.[0];
        const slug = String(row?.seo_slug || '').trim();
        if (slug) slugCache.set(cleanId, slug);
        return slug || null;
      } catch { return null; }
      finally { pending.delete(cleanId); }
    })();
    pending.set(cleanId, job);
    const slug = await job;
    return slug ? seoUrl(slug, sourceHref) : null;
  }

  window.CaraviumAreaSEO = { urlForId: getSeoUrl, extractId };

  async function upgradeAnchor(a) {
    if (!a?.getAttribute) return;
    const href = a.getAttribute('href');
    const id = extractId(href);
    if (!id || !href?.includes('ficha-area-caravium')) return;
    a.dataset.caraviumAreaId = id;
    const url = await getSeoUrl(id, href);
    if (url && a.isConnected) a.setAttribute('href', url);
  }

  function scan(root = document) {
    if (root.matches?.('a[href*="ficha-area-caravium"]')) upgradeAnchor(root);
    root.querySelectorAll?.('a[href*="ficha-area-caravium"]').forEach(upgradeAnchor);
  }

  async function redirectLegacyFicha() {
    if (location.pathname !== LEGACY_PATH) return;
    const id = new URLSearchParams(location.search).get('id');
    if (!id) return;
    const url = await getSeoUrl(id, location.href);
    if (!url) return;
    location.replace(`${url}${location.hash || ''}`);
  }

  document.addEventListener('click', async (event) => {
    const a = event.target.closest?.('a');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (!href.includes('ficha-area-caravium')) return;
    const id = extractId(href);
    if (!id) return;
    event.preventDefault();
    const url = await getSeoUrl(id, href);
    location.href = url || a.href;
  }, true);

  function init() {
    scan(document);
    redirectLegacyFicha();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) for (const node of mutation.addedNodes) if (node instanceof Element) scan(node);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* CARAVIUM LIVE FICHA HOTFIX V2 — only on SEO ficha pages */
(() => {
  'use strict';

  const PATH = location.pathname;
  const match = PATH.match(/^\/apps\/pernoctar\/(?!guia-).+-(\d+)\/?$/);
  if (!match) return;

  const spotId = match[1];
  const SB = 'https://ouhtkmpgsmauyebwpqsj.supabase.co';
  const KEY = 'sb_publishable_CBwe_LRkZmEii18EiiUtuA_uxonULzb';
  let spot = null;
  let loading = false;

  const esc = (v) => String(v ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  async function loadSpot() {
    if (spot || loading) return spot;
    loading = true;
    try {
      const r = await fetch(`${SB}/rest/v1/spots?id=eq.${encodeURIComponent(spotId)}&select=id,direccion,municipio,provincia,comunidad_autonoma&limit=1`, {
        headers: { apikey: KEY, Authorization: `Bearer ${KEY}` }
      });
      if (r.ok) spot = (await r.json())?.[0] || null;
    } catch {}
    loading = false;
    return spot;
  }

  function findContactSection() {
    const direct = document.querySelector('#cv-contacto');
    if (direct) return direct;
    return Array.from(document.querySelectorAll('#caravium-area-ficha section, #caravium-area-ficha .cv-section')).find(sec => {
      const h = sec.querySelector('h2');
      return h && h.textContent.trim().toLowerCase() === 'contacto y dirección';
    }) || null;
  }

  function visibleRealAddress(sec) {
    const cards = Array.from(sec.querySelectorAll('.cv-contact-card'));
    return cards.some(card => {
      const txt = String(card.textContent || '').trim().toLowerCase();
      const rect = card.getBoundingClientRect();
      return txt.includes('dirección') && txt.replace(/dirección/g,'').trim().length > 4 && rect.width > 20 && rect.height > 20;
    });
  }

  async function ensureContact() {
    const data = await loadSpot();
    if (!data || !data.direccion) return;
    const sec = findContactSection();
    if (!sec) return;

    const oldForced = sec.querySelector('.cv-contact-force-hotfix');
    if (visibleRealAddress(sec)) {
      oldForced?.remove();
      return;
    }
    if (oldForced) return;

    const card = document.createElement('div');
    card.className = 'cv-contact-force-hotfix';
    card.style.cssText = 'display:flex!important;align-items:flex-start!important;gap:14px!important;border:1px solid #e1e8ec!important;border-radius:18px!important;padding:18px!important;background:#fff!important;margin-top:16px!important;box-sizing:border-box!important;width:100%!important;min-height:82px!important;visibility:visible!important;opacity:1!important;color:#102638!important;';
    const locality = [data.municipio, data.provincia || data.comunidad_autonoma].filter(Boolean).join(' · ');
    card.innerHTML = `<div style="width:44px;height:44px;min-width:44px;display:flex;align-items:center;justify-content:center;border-radius:13px;background:#eef7f6;font-size:22px">📍</div><div style="min-width:0;line-height:1.55;color:#102638"><strong style="display:block;margin-bottom:4px;font-size:15px">Dirección</strong><div>${esc(data.direccion)}</div>${locality ? `<div style="font-size:13px;color:#687986;margin-top:3px">${esc(locality)}</div>` : ''}</div>`;

    const head = sec.querySelector('.cv-section-head');
    if (head) head.insertAdjacentElement('afterend', card);
    else {
      const h2 = sec.querySelector('h2');
      if (h2) h2.insertAdjacentElement('afterend', card);
      else sec.prepend(card);
    }
  }

  function moveNearby() {
    const el = document.getElementById('cv-nearby-floating');
    if (!el) return;
    el.style.setProperty('position','fixed','important');
    el.style.setProperty('left','auto','important');
    el.style.setProperty('transform','none','important');
    el.style.setProperty('right', innerWidth <= 800 ? '12px' : '24px','important');
    el.style.setProperty('bottom', innerWidth <= 800 ? '150px' : '120px','important');
    el.style.setProperty('z-index','2147483000','important');
  }

  function tick() {
    ensureContact();
    moveNearby();
  }

  function start() {
    tick();
    const root = document.getElementById('caravium-area-ficha') || document.body;
    new MutationObserver(tick).observe(root, { childList:true, subtree:true });
    addEventListener('resize', moveNearby);
    setTimeout(tick, 400);
    setTimeout(tick, 1200);
    setTimeout(tick, 2500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();

/* CARAVIUM GLOBAL AÑADIR LUGAR V1 */
(() => {
  'use strict';

  const ADD_URL = '/pages/comunidad-caravium?add=1';

  function ensureStyles() {
    if (document.getElementById('cv-global-add-place-styles')) return;
    const style = document.createElement('style');
    style.id = 'cv-global-add-place-styles';
    style.textContent = `
      .cv-global-add-nav{display:inline-flex!important;align-items:center!important;gap:7px!important;padding:9px 14px!important;border-radius:999px!important;background:#20b9aa!important;color:#fff!important;font-weight:900!important;text-decoration:none!important;white-space:nowrap!important;box-shadow:0 4px 14px rgba(0,0,0,.12)!important}
      .cv-global-add-nav:hover{filter:brightness(.96);color:#fff!important}
      #cv-global-add-mobile{display:none;position:fixed;left:14px;bottom:84px;z-index:2147482500;border:0;border-radius:999px;padding:12px 15px;background:#20b9aa;color:#fff;font:inherit;font-weight:900;box-shadow:0 7px 22px rgba(0,0,0,.28);cursor:pointer}
      @media(max-width:749px){#cv-global-add-mobile{display:inline-flex;align-items:center;gap:7px}.cv-global-add-nav{display:none!important}}
    `;
    document.head.appendChild(style);
  }

  function addDesktopLauncher() {
    if (document.querySelector('.cv-global-add-nav')) return;
    const nav = document.querySelector('#header-group .header-menu .menu-list__list');
    if (!nav) return;
    const li = document.createElement('li');
    li.className = 'menu-list__list-item cv-global-add-nav-item';
    const a = document.createElement('a');
    a.href = ADD_URL;
    a.className = 'cv-global-add-nav';
    a.setAttribute('aria-label','Añadir un lugar a CARAVIUM');
    a.textContent = '➕ Añadir lugar';
    li.appendChild(a);
    nav.appendChild(li);
  }

  function addMobileLauncher() {
    if (document.getElementById('cv-global-add-mobile')) return;
    const button = document.createElement('button');
    button.id = 'cv-global-add-mobile';
    button.type = 'button';
    button.setAttribute('aria-label','Añadir un lugar a CARAVIUM');
    button.innerHTML = '<span aria-hidden="true">➕</span><span>Añadir lugar</span>';
    button.addEventListener('click', () => { location.href = ADD_URL; });
    document.body.appendChild(button);
  }

  function autoOpenCommunityForm() {
    if (location.pathname !== '/pages/comunidad-caravium' && location.pathname !== '/pages/pagina-comunidad-caravium') return;
    if (new URLSearchParams(location.search).get('add') !== '1') return;
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const trigger = document.querySelector('[data-cvc-mode="new"]');
      if (trigger) {
        clearInterval(timer);
        trigger.click();
        try {
          const u = new URL(location.href);
          u.searchParams.delete('add');
          history.replaceState({}, '', u.pathname + (u.search ? u.search : '') + u.hash);
        } catch {}
      } else if (tries > 30) {
        clearInterval(timer);
      }
    }, 150);
  }

  function initGlobalAddPlace() {
    ensureStyles();
    addDesktopLauncher();
    addMobileLauncher();
    autoOpenCommunityForm();

    const header = document.getElementById('header-group');
    if (header) {
      new MutationObserver(() => addDesktopLauncher()).observe(header,{childList:true,subtree:true});
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGlobalAddPlace, {once:true});
  else initGlobalAddPlace();
})();